import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ColumnDropDownDto } from './column-drop-down-dto';




export class ColumnsDropDownResponseModel extends GlobalResponseObject {
    data?: ColumnDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ColumnDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

